import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {firestore} from "../../config/firebaseConfig";
import {FILTER_INITIAL_STATE, FILTER_STATUS_ALL} from "../../components/Po/constants";
import {STATUS_FAILED, STATUS_IDLE, STATUS_PENDING} from "../../constants";

import { cartOrderCollection, vendors } from 'src/constant/firestore'


export const getPurchasesCart = createAsyncThunk(
    'POCart/get',
    async ({filter = FILTER_INITIAL_STATE, limit = 30, loadMore = false}, thunkAPI) => {
        return new Promise(async (resolve, reject) => {
            try {
                const {cursor,snapShot, list} = thunkAPI.getState()?.purchaseCart; 

                
                let queryRef = vendors
            
    
                const docSnap = loadMore
                    ? await queryRef.startAfter(cursor).get()
                    : await queryRef.get();
    

                const result = docSnap.docs.map(doc => ({ id: doc.id, key: doc.id, ...doc.data() }));

                resolve({
                    list: (loadMore && list) ? [...list, ...result] : [...result],
                    noResult: (result.length === 0),
                    snapShot: {
                        filter: filter,
                        cursor: docSnap.docs[docSnap.docs.length - 1]
                    }
                });
            } catch (e) {
                console.log(e)
                reject(e)
            }
        })
    }
)

const purchasingOrdersSlice = createSlice({
    name: 'PurchaseCart',
    initialState: {
        list: null,
        status: STATUS_IDLE,
        noResult: false,
        snapShot: {
            filter: null,
            cursor: null
        }
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getPurchasesCart.pending, state => {
                state.status = STATUS_PENDING;
                state.noResult = false;
            })
            .addCase(getPurchasesCart.rejected, state => {
                state.status = STATUS_FAILED;
            })
            .addCase(getPurchasesCart.fulfilled, (state, action) => {
                state.status = STATUS_IDLE;
                state.list = action.payload.list; 
                state.noResult = action.payload.noResult;
                state.snapShot = action.payload.snapShot;
            })
    }
})

export const selectPurchCart = state => state.purchaseCart;

export default purchasingOrdersSlice.reducer;

